module.exports = __webpack_public_path__ + "media/images/products/retailers-socialmedia-6-excerpt-page-f1a3d5133e4188656e0584cce3f2fc1f.jpg";